import { cn } from '../../../../classname';
export var CheckboxNode;
(function (CheckboxNode) {
    CheckboxNode["Checkbox"] = "checkbox";
    CheckboxNode["Input"] = "checkbox_input";
    CheckboxNode["Label"] = "checkbox_label";
})(CheckboxNode || (CheckboxNode = {}));
export const idPrefix = 'yfm-editor-checkbox';
export const b = cn('checkbox');
